import { apiZoho } from '#plugins/axios.js';

export const getStockByStore = async (storeIds) => {
  const queryStore = [];
  if (Array.isArray(storeIds))
    storeIds.forEach((storeId) => queryStore.push(`Bodega.ID==${storeId}`));
  else queryStore.push(`Bodega.ID==${storeIds}`);

  const whereQueryStores = queryStore.join('||');

  const response = await apiZoho.get('Stock_model_Chacam_Report', {
    params: {
      where: `Cantidad>0&&(${whereQueryStores})`,
    },
  });

  return response.data.data;
};
